import { Block, Container, Heading, RichText } from '~/components'
import * as styles from './GallerySelectionBlock.css'
import type { GallerySelectionBlock } from './types'
import type { Image as ImageType, StoryblokStory } from '~/lib/storyblok'
import Link from 'next/link'
import { transformImageResize } from '~/lib/storyblok/transformImageResize'
import Image from 'next/image'

type Props = {
  block: GallerySelectionBlock
}

type Gallery = {
  id: number
  name: string
  slug: string
  image: ImageType
}

export function GallerySelectionBlock({ block }: Props) {
  const galleries = block.pages.map((page: StoryblokStory) => {
    let image

    for (const block of page.content.blocks) {
      if (block.component === 'GalleryGridBlock') {
        if (block.images?.length > 0) {
          const firstImage = block.images[0]
          if (firstImage?.filename) {
            image = transformImageResize(firstImage, {
              width: 1920,
              quality: 100,
            })
          }
        }
      }
    }

    return {
      id: page.id,
      name: page.name,
      slug: page.full_slug,
      image,
    }
  }) as Gallery[]

  return (
    <Block options={block.options}>
      <Container>
        <div className={styles.content}>
          <div className={styles.main}>
            {block.title && <Heading margin="medium">{block.title}</Heading>}
            <div className={styles.galleries}>
              {galleries.map((gallery) => (
                <Link href={`/${gallery.slug}`} key={gallery.id} className={styles.gallery}>
                  {gallery.image && (
                    <div className={styles.canvas}>
                      <Image
                        src={gallery.image.url}
                        width={gallery.image.width}
                        height={gallery.image.height}
                        alt={gallery.name}
                        className={styles.image}
                      />
                    </div>
                  )}
                  <h3 className={styles.name}>{gallery.name}</h3>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </Block>
  )
}
